<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormRequisiciones" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <CList @FiltrarC="Recuperar" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
                        <template slot="header">
                            <th :class="StyleTh+' text-center'">#</th>
                            <th :class="StyleTh">Folio</th>
                            <th :class="StyleTh">Proveedor</th>
                            <th :class="StyleTh">Departamento</th>
                            <th :class="StyleTh">Fecha Exp.</th>
                            <th :class="StyleTh">Total</th>
                            <th :class="StyleTh">Elegir</th>
                        </template>

                        <template slot="body">
                            <tr v-for="(lista,index) in Requisiciones" :key="index">
                                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					            <td><h6 :class="StylePr">{{lista.Folio}}</h6></td>
                                <td><p :class="StyleTd">{{ lista.Proveedor }}</p></td>
                                <td><p :class="StyleTd">{{ lista.Departamento }}</p></td>
                                <td><p :class="StyleTd">{{ $getCleanDate(lista.FechaExp,true) }}</p></td>
                                <td><p :class="StyleTd">$ {{ lista.Total }}</p></td>
                                <td>
                                    <button @click="SeleccionarRequisicion(lista)" type="button" v-b-tooltip.hover.Top title="Seleccionar Requisicion" class="btn btn-link text-primary px-3 mb-0 mr-1"><i class="fas fa-check-circle"></i> Agregar</button>
                                </td>
                            </tr>
                            <CSinRegistros :pContIF="Requisiciones.length" :pColspan="7"></CSinRegistros>
                        </template>
                    </CList>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
export default {
    name: 'FormProveedores',
    props:['poBtnSave'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
            Emit: this.poBtnSave.EmitSeccion,
            ConfigList:{
                Title:'Requisiciones',
                BtnNewShow:false,
                ShowTitleFirst: false,
                ShowLoader: false,
                ShowFooter:false
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            segurity: {},
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Requisiciones:[]
        }
    },
    methods: {
        Recuperar(){
            this.ConfigLoad.ShowLoader=true;
            this.$http.get("requisicionesAutorizadas",{
                params:{
                    Nombre: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res)=>{
                this.Requisiciones=res.data.data.data;
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        SeleccionarRequisicion(item){
            this.bus.$emit('SeleccionarRequisicion',item);
        }
    },
    created() {
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.poBtnSave.DisableBtn = false;
            this.Recuperar();
        });
    },
}
</script>

<style>

</style>